// CompareDevices.js
import React, { useState, useEffect } from "react";
import axios from "axios";
import "./CompareDevices.css";
import {
  Header,
  DevicesFilters,
  ProductsSpecs,
} from "../../Features/Compare Devices";
import { toast } from "react-toastify";

const CompareDevices = ({ url }) => {
  // omarg
  // removed state and used localstorage instead

  // Try localStorage, then empty
  const persisted = JSON.parse(localStorage.getItem("compareList") || "null") || [];

  // Map to your dropdown shape, then pad to 4
  const makeInitial = (list) => {
    const items = list.map((item) => ({
      label: item.website_name,
      id: item.name,
      image:
        item.image && item.image !== "null"
          ? `${url}/${item.image}`
          : "",
    }));
    while (items.length < 4) items.push(null);
    return items;
  };

  // Initialize with 4 dropdowns
  const [selectedDevices, setSelectedDevices] = useState(
    makeInitial(persisted)
  );

  useEffect(() => {
    // Only store the non-null ones
    const toStore = selectedDevices.filter(Boolean).map((d) => ({
      website_name: d.label,
      name: d.id,
      image: d.image ? d.image.replace(`${url}/`, "") : null,
    }));
    localStorage.setItem("compareList", JSON.stringify(toStore));
  }, [selectedDevices]);

  const [deviceData, setDeviceData] = useState(null);
  const [deviceOptions, setDeviceOptions] = useState([]);
  const [showDifferencesOnly, setShowDifferencesOnly] = useState(false);
  const [labels, setLabels] = useState({});

  const [allData, setAllData] = useState({})

  // Fetch device options for dropdowns
  const fetchDeviceOptions = async (searchTerm = "") => {
    try {
      const body = {
        item_group: "Tracking Devices",
        limit: 100,
        ...(searchTerm && { name: searchTerm }),
      };
      const apiUrl = `${url}/api/method/webshop.webshop.doctype.website_item.website_item.items`;
      const response = await axios.get(apiUrl, {
        headers: { "Content-Type": "application/json" },
        params: body,
      });
      if (response.data.status_code !== 200) {
        toast.error("Failed to fetch devices. Please try again.");
        return;
      }
      const devices = response.data.result.objects || [];
      const options = devices.map((device) => ({
        label: device.web_item_name,
        id: device.name,
        image: device.website_image ? `${url}${device.website_image}`: null,
      }));
      setDeviceOptions(options);
    } catch (error) {
      toast.error("Failed to fetch device options. Please try again.");
    }
  };
  const [hashmapSpecifications, setHashmapSpecifications] = useState({});

  function extractSpecifications(data, result = {}) {
    for (const [key, value] of Object.entries(data)) {
        if (typeof value === 'object' && value !== null) {
            if (value.is_group === 0) {
                result[key] = value;
            } else {
              // omarg
              // If value.order exists, then add the key, this is used to order compared specifications
              if (value.order) {
                if (!result[key]) {
                  result[key] = {};
                }
                result[key].order = value.order;
              }
              extractSpecifications(value, result);
            }
        }
    }
    return result;
}

  // Fetch data for selected devices
  const fetchData = async () => {
    const dynamicItemList = selectedDevices
      .map((device) => device?.id)
      .filter(Boolean);
    if (dynamicItemList.length < 2) {
      setDeviceData(null);
      return;
    }
    try {
      const body = {
        item_group: "Tracking Devices",
        item_list: dynamicItemList,
      };
      const apiUrl = `${url}/api/method/webshop.webshop.doctype.website_item.compare.compare`;
      const response = await axios.post(apiUrl, body, {
        headers: { "Content-Type": "application/json" },
      });
      if (response.data.status_code === 200) {
        const fetchedData = response.data.result;

        
      let _temp = extractSpecifications(response?.data?.result?.specifications);
      let updatedTemp = { ..._temp, ...extractSpecifications(response?.data?.result?.features) };

      setHashmapSpecifications(updatedTemp);
      
      setAllData(response?.data?.result)
      
        // محاذاة fetchedData.items مع selectedDevices
        const alignedItems = selectedDevices.map((device) => {
          if (!device) return null;
          const item = fetchedData.items.find((data) => data.name === device.id);
          return item || null;
        });
        // تحديث fetchedData.items لتكون alignedItems
        fetchedData.items = alignedItems;

        setDeviceData(fetchedData);
        setLabels(fetchedData.labels);
      } else {
        toast.error("Failed to fetch data.");
      }
    } catch (error) {
      toast.error("Failed to fetch data.");
    }
  };

  // Fetch device options when component mounts
  useEffect(() => {
    fetchDeviceOptions();
  }, []);

  // Fetch comparison data when selected devices change
  useEffect(() => {
    fetchData();
  }, [selectedDevices]);

  // Handle dropdown changes
  const handleDeviceChange = (index, newValue) => {
    let updatedDevices = [...selectedDevices];
    const prevDevice = selectedDevices[index];
    updatedDevices[index] = newValue;

    // إذا كان المستخدم يحاول إلغاء تحديد جهاز
    if (prevDevice && !newValue) {
      // عدد الأجهزة المختارة بعد التغيير
      const selectedCount = updatedDevices.filter((device) => device).length;
      // منع إلغاء التحديد إذا كان سيؤدي إلى اختيار أقل من جهازين
      if (selectedCount < 2) {
        toast.warning("At least two devices must be selected for comparison.");
        return;
      }
    }

    setSelectedDevices(updatedDevices);
  };

  return (
    <div className="CompareDevices">
      <div className="CompareDevices-container container">
        <Header />
        <div className="sticky-filters">
          <DevicesFilters
            selectedDevices={selectedDevices}
            handleDeviceChange={handleDeviceChange}
            deviceOptions={deviceOptions}
            showDifferencesOnly={showDifferencesOnly}
            setShowDifferencesOnly={setShowDifferencesOnly}
          />
        </div>
        <ProductsSpecs
          deviceData={deviceData}
          url={url}
          showDifferencesOnly={showDifferencesOnly}
          labels={labels}
          hashmapSpecifications={hashmapSpecifications}
          allData={allData}
        />
      </div>
    </div>
  );
};

export default CompareDevices;
